export default __webpack_public_path__ + "static/logo-small-black.c31eb8891048fbae345bd0bc4d668db5.png";